// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".sub-resource-table .application--wrap[data-v-440ae1f4] {\n  min-height: 1vh !important;\n}\n.header[data-v-440ae1f4] {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 20px;\n}\n.briq-alert[data-v-440ae1f4] {\n  margin-bottom: 16px;\n}\n", ""]);
// Exports
module.exports = exports;
